import React from 'react';
import { useTranslation } from 'react-i18next';

import { CrossCircle } from '@zooplus/icons';
import {
  H4,
  ModalBody,
  ModalFooter,
  ModalSecondaryButton,
  ModalWrapper,
  P1,
} from '@zooplus/ui-components';

import { braintreeTracking } from '../../../services/diiService';

export type RetryPaymentBraintreeModalErrorProps = {
  show: boolean;
};

const RetryPaymentBraintreeModalError: React.FC<RetryPaymentBraintreeModalErrorProps> = ({
  show,
}) => {
  const { t } = useTranslation();
  const redirectToOrderOverviewPage = () => {
    braintreeTracking('BTretryPopupErrorClose');
    window.location.replace(window.location.origin + window.location.pathname);
  };

  return (
    <ModalWrapper
      size="md"
      isShown={show}
      onClose={() => {
        braintreeTracking('BTretryPopupErrorClose');
      }}
      heading={t('checkout.payment.by.card')}
      closeBtnAriaLabel="Close"
      headingId="retry-payment-card">
      <ModalBody className={'v3-text--center'}>
        <CrossCircle color="#e10000" height={60} width={60} />
        <H4>There was a problem with your payment.</H4>
        <P1>Please try again later.</P1>
      </ModalBody>
      <ModalFooter>
        <ModalSecondaryButton onClick={() => redirectToOrderOverviewPage()}>
          Close
        </ModalSecondaryButton>
      </ModalFooter>
    </ModalWrapper>
  );
};

export default RetryPaymentBraintreeModalError;
